import { CommentStatus } from '../modules/app';

export const COMMENT_STATUS: { [key: string]: CommentStatus } = {
  DELETED: 'deleted',
};
